const GridConfig = {
  // Used by Column Components to calculate space between elements in the grid.
  // The values listed here are half the expected gutters as they are applied
  // to both left and right. E.g. if the gutter is 1rem, the value must be 0.5rem
  gutters: {
    // breakpoint: value, // actual gutter -> divided by 2
    mobile: '0.5rem', // 16px -> 8px
    tablet: '0.5rem', // 16px -> 8px
    desktop: '0.5rem', // 16px -> 8px
    desktopWide: '0.75rem', // 24px -> 12px
  },

  // Used to set the max-width of containers so that we don't continue to grow beyond those rems.
  maxWidths: {
    mobile: '100%',
    tablet: '100%', // 768px
    desktop: '82rem', // 1024px
    desktopWide: '90rem', // 1440px
  },

  // How much padding to apply to containers
  // By default, only used by the Container component for padding-left-right
  offsets: {
    mobile: '1.5rem', // 24px
    tablet: '1.5rem', // 28px
    desktop: '3.75rem', // 60px
    desktopWide: '7.5rem', // 120px
  },

  // Use resets to reset something to zero across all breakpoints.
  // E.g. last row should have no bottom margin inside its container.
  resets: {
    mobile: '0px',
    tablet: '0px',
    desktop: '0px',
    desktopWide: '0px',
  },

  // Vertical spacing between elements at each breakpoint (margin-bottom)
  // Typically used on rows, but can also be used on columns.
  vspace: {
    mobile: 0,
    tablet: 0,
    desktop: 0,
    desktopWide: 0,
  },

  // Viewports are the minimum widths of screen sizes.
  // We can use these when we need to calculate relative percentages
  // This only differs from breakpoints for mobile.
  // We keep this in pixels to match the breakpoints object.
  viewports: {
    mobile: 360,
    tablet: 768,
    desktop: 1024,
    desktopWide: 1440,
  },

  // Widths of container at each breakpoint. 1 indicates 100%.
  // Use with maxWidths to stop growing
  widths: {
    mobile: 1,
    tablet: 1,
    desktop: 1,
    desktopWide: 1,
  },
};

/* @component */
export default GridConfig;
